import { useCallback, useState } from 'react';
import {
  assignLogisticResponsibleUser,
  deleteLogisticResponsibleUser,
  getLogisticResponsibleUsersList
} from 'services/responsibleUsers.service';
import useUsersState from 'state/useUsersState';
import { IbackofficeUserData } from 'types/configuration.types';
import { IResponsibleUserData } from 'types/responsibleUser.types';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

export const useBordResponsibleUserDataForLogisticService = (id?: number) => {
  const { users } = useUsersState();

  const [responsibleUserList, setResponsibleUserList] = useState<IResponsibleUserData[]>([]);

  const [isLoading, setIsLoading] = useState(false);

  const getResponsibleUserList = useCallback(() => {
    if (!id) return;
    setIsLoading(true);
    getLogisticResponsibleUsersList(id)
      .then(response => {
        if (response) setResponsibleUserList(response);
      })
      .catch(() => {
        displayErrorNotification();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  const assignResponsible = async (user: IbackofficeUserData) => {
    if (!id || !user) return;
    setIsLoading(true);

    try {
      const orderBody = {
        logisticServiceId: Number(id),
        userId: user.id
      };
      const response = await assignLogisticResponsibleUser(orderBody);
      if (response) getResponsibleUserList();
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  const deleteResponsible = async (responsibleId?: number, userName?: string) => {
    if (!id || !responsibleId) return;
    setIsLoading(true);
    try {
      await deleteLogisticResponsibleUser(responsibleId);
      setResponsibleUserList(responsibleUserList.filter(user => user.id !== responsibleId));

      getResponsibleUserList();
      displaySuccessNotification({
        customJSXMessage: <div>Se eliminó al responsable {userName} de este servicio exitosamente</div>
      });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    responsibleUserList,
    userList: users,
    isLoading,
    getResponsibleUserList,
    assignResponsible,
    deleteResponsible
  };
};
